const ERROR_MESSAGE = {
  email: 'Invalid email address',
  required: 'This field is required',
  invalid: 'Invalid format',
  maxLength: (limit: number) => `Must be shorter than or equal to ${limit.toString()} characters`
} as const;

export { ERROR_MESSAGE };
